import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  FormGroup,
  Label,
  Input,
  Spinner,
  Row,
  Col,
} from "reactstrap";
import { updateAdditionalCharge } from "store/actions/settingAction";

const EditAdditionalChargesModal = ({ editModal, editToggle, editData }) => {
  const [name, setName] = useState("");
  const [type, setType] = useState("");
  const [fee, setFee] = useState("");
  const [isActive, setIsActive] = useState(false);
  const [isChanged, setIsChanged] = useState(false);
  const [loading, setLoading] = useState(false);
  const { user } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const handleFeeChange = (e) => {
    const inputValue = e.target.value.replace(/[^0-9]/g, "");
    setFee(inputValue);
  };

  const handleCancelToggle = () => {
    if (editData) {
      setName(editData.name || "");
      setType(editData.type || "");
      setFee(editData.fee !== undefined ? String(editData.fee) : "");
      setIsActive(editData.isActive || false);
    }
    editToggle();
  };

  const handleUpdate = async () => {
    if (!name || !type || !fee) return;
    const updatedData = {
      ...editData,
      name,
      type,
      fee: Number(fee),
      isActive,
    };
    try {
      setLoading(true);
      await dispatch(
        updateAdditionalCharge(user?.id, updatedData, () => {
          toast.success("Updated successfully!");
        })
      );
      editToggle();
    } catch (error) {
      toast.error("Update failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (editData) {
      setName(editData.name || "");
      setType(editData.type || "");
      setFee(editData.fee !== undefined ? String(editData.fee) : "");
      setIsActive(editData.isActive || false);
    }
  }, [editData]);

  useEffect(() => {
    if (!editData) return;
    const hasChanged =
      name !== (editData.name || "") ||
      type !== (editData.type || "") ||
      fee !== (editData.fee !== undefined ? String(editData.fee) : "") ||
      isActive !== (editData.isActive || false);

    setIsChanged(hasChanged);
  }, [name, type, fee, isActive, editData]);

  return (
    <Modal isOpen={editModal} toggle={handleCancelToggle}>
      <ModalHeader toggle={handleCancelToggle}>
        Edit Additional Charge
      </ModalHeader>
      <ModalBody className="pt-0">
        <Form>
          <FormGroup>
            <Label for="editChargeName">Name</Label>
            <Input
              type="text"
              id="editChargeName"
              placeholder="Service Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </FormGroup>

          <FormGroup>
            <Label for="editChargeType">Type</Label>
            <Input
              type="select"
              id="editChargeType"
              value={type}
              onChange={(e) => setType(e.target.value)}
            >
              <option value="" disabled hidden>
                Select type
              </option>
              <option value="percentage">Percentage</option>
              <option value="fixed">Fixed</option>
            </Input>
          </FormGroup>

          <FormGroup>
            <Label for="editChargeFee">Fee</Label>
            <Input
              type="text"
              id="editChargeFee"
              placeholder="Enter amount"
              value={fee}
              onChange={handleFeeChange}
            />
          </FormGroup>

          <Row>
            <Col>
              <div className="form-check w-100 p-0 d-flex align-items-center justify-content-start">
                <Input
                  type="checkbox"
                  className="form-check-input timing-modal-checkbox m-0"
                  id="applyAllCheckbox"
                  value={isActive}
                  checked={isActive}
                  onChange={() => setIsActive(!isActive)}
                />
                <label
                  className="form-check-label timing-modal-checkbox-label ml-2"
                  htmlFor="applyAllCheckbox"
                >
                  Do you want to activate these charges?
                </label>
              </div>
            </Col>
          </Row>

          {/* <FormGroup check>
            <Input type="checkbox" id="editChargeIsActive" checked={isActive} />
            <Label for="editChargeIsActive" check>
              Do you want to activate this charge?
            </Label>
          </FormGroup> */}

          <div className="d-flex justify-content-end mt-3">
            <Button
              color="primary"
              type="button"
              onClick={handleUpdate}
              disabled={!isChanged || !name || !type || !fee || loading}
            >
              {loading ? <Spinner color="secondary" size="sm" /> : "Update"}
            </Button>
          </div>
        </Form>
      </ModalBody>
    </Modal>
  );
};

export default EditAdditionalChargesModal;
